{
  "Kullanıcılar": "Kullanıcılar",
  "kullanicilar": {
    "Admin Olanlar": "Yöneticiler",
    "Admin Olmayanlar": "Yönetici Olmayanlar",
    "Bilgisayardan Yükle": "Bilgisayardan Yükle",
    "Evet, değiştir": "Evet, değiştir.",
    "Fotoğrafı Düzenle": "Fotoğrafı Düzenle",
    "Group Yetki": "Grup Yetkisi",
    "Güvenlik": "Güvenlik",
    "Henüz fotoğraf seçilmedi veya çekilmedi": "Henüz fotoğraf seçilmedi veya çekilmedi.",
    "Kullanıcı Profil": "Kullanıcı Profili",
    "Kullanıcılar": "Kullanıcılar",
    "Resmi sürükleyerek konumlandırabilirsiniz": "Resmi sürükleyerek konumlandırabilirsiniz.",
    "Sağa Döndür": "Sağa Döndür",
    "Sola Döndür": "Sola Döndür",
    "Yeni Group Yetki": "Yeni Grup Yetkisi",
    "Yetki": "Yetki",
    "Yetkileri": "Yetkiler",
    "veya Webcam Kullan": "veya Webcam Kullan",
    "Çek": "Fotoğraf Çek",
    "Önizleme": "Önizleme",
    "İsim": "İsim",
    "Şifre Değişikliği Yapılıyor?": "Şifre Değişikliği Yapılıyor?",
    "Ara": "Ara",
    "Temizle": "Temizle",
    "Kapat": "Kapat",
    "Durum": "Durum",
    "Yenile": "Yenile",
    "E-mail": "E-posta",
    "Admin": "Yönetici",
    "Yeni Kullanıcı": "Yeni Kullanıcı",
    "Kayıt": "Kayıt",
    "Güncelle": "Güncelle",
    "Sil": "Sil",
    "Şifreyi Güncelle": "Şifreyi Güncelle",
    "Ad Soyad": "Ad Soyad",
    "E-posta Şifresi Değiştir": "E-posta Şifresi Değiştir",
    "Yeni E-posta Şifresi": "Yeni E-posta Şifresi",
    "Email": "E-posta",
    "Grafikler": "Grafikler",
    "Onaylı": "Onaylı",
    "Onaysız": "Onaysız",
    "Toplam": "Toplam",
    "Hedef": "Hedef",
    "Yapılan": "Yapılan",
    "Randevu": "Randevu",
    "Referans": "Referans",
    "Satış": "Satış",
    "Sira": "Sıra",
    "Kod": "Kod",
    "Baslik": "Başlık",
    "UstKod": "Üst Kod",
    "GrupBaslik": "Grup Başlığı",
    "YetkiListesi": "Yetki Listesi",
    "DataYenile": "Yenile",
    "Aktif": "Aktif",
    "Pasif": "Pasif",
    "Aksiyonlar": "Aksiyonlar",
    "YetkiDuzenle": "Yetki Düzenle",
    "YetkiEkle": "Yetki Ekle",
    "Iptal": "İptal",
    "Kaydet": "Kaydet",
    "SilmeOnayi": "Silme Onayı",
    "YetkiSilmeMesaji": "{name} yetkisini silmek istediğinize emin misiniz?",
    "Hayir": "Hayır",
    "Evet": "Evet",
    "Aciklama": "Açıklama",
    "Mesai": "Mesai"
  }
}
